import { CONTENT_CARD_CLICK, CONTENT_CARD_CLICK_API_ERROR, CONTENT_CARD_CLICK_SUCCESS } from "./ActionTypes";
  
  const initialState = {
    error: "",
    loading: false,
  };
  
  const ContentCard = (state = initialState, action) => {
    switch (action.type) {

        //Content Card onclick
        case CONTENT_CARD_CLICK:
          state = {
            ...state,
            loading: true,
          };
          break;
          case CONTENT_CARD_CLICK_SUCCESS:
          state = {
            ...state,
            contentCardData:action.payload.data,
            loading: false,
          };
          break;
        case CONTENT_CARD_CLICK_API_ERROR:
          state = {
            ...state,
            error: action.payload.data,
            loading: false,
            isUserLogout: false,
          };
          break;
       
      default:
        state = { ...state };
        break;
    }
    return state;
  };
  
  export default ContentCard;
  